import * as React from 'react';

import './style.scss';

const SecondPart = React.memo(() => <div className="P-clinic-about-us-second-part P-clinic-about-us-tablet">
  <div className="P-content">
    <span className="P-main-color-border" />
    <p className="G-text-bold">Լաբորատորիա</p>
    <br/>
    <p>Էքսպրես-կլինիկայի լաբորատոր բաժանմունքում գործում է INVITROARMENIA լաբորատորիան, որն անցկացնում է ավելի քան 2000 լաբորատոր հետազոտություններ։ </p>
    <br/>
    <p>Invitro լաբորատորիան ունի շուրջ 1500 մասնաճյուղ ողջ ԱՊՀտարածքում: Արդյունքների պատրաստ լինելուն պես կստանաքտեղեկատվություն՝ Ձեզ հարմար տարբերակով՝ SMS, էլ.փոստ,invitromed.am կայքէջում բացված անձնական կաբինետ, ցանկությանդեպքում՝ անմիջապես գրասենյակից կամ փոստային առաքման միջոցով:</p>
    <br/>
    <p>Գրանցվելու համար կարող եք զանգահարել 060 651 011, 060 700 500հեռախոսահամարով (ներքին՝ 300), invitromed.am  կայքէջով կամ գրելմեր սոց. ցանցերի էջերին:</p>
    <br/>
    <p>Աշխ. ժամերը՝ երկ-շբթ 08:00-16:00։</p>
    <br/>
    <p className="G-text-bold">Թերապեւտ</p>
    <br/>
    <p>Կարող եք դիմել՝</p>
    <ul>
      <li>սիրտ-անոթային համակարգի խնդիրների՝ սրտի իշեմիկհիվանդության, զարկերակային գերճնշման եւ այլն,</li>
      <li>շնչառական համակարգի՝ սուր շնչառական հիվանդությունների,քրոնիկ բրոնխիտների, սուր թոքաբորբերի, քրոնիկ թոքայինխցանող հիվանդության, ասթմայի եւ այլն,</li>
      <li>աղեստամոքսային համակարգի՝ սուր եւ քրոնիկ գաստրիտների,էնտերիտների, խոցային հիվանդության եւ այլն,</li>
      <li>միզամուղ համակարգի՝ սուր եւ քրոնիկ բորբոքումների, երիկամիքարերի եւ այլն,</li>
      <li>հենաշարժիչ համակարգի՝ արթրիտների, միոզիտների եւ այլն,</li>
      <li>ախտորոշման, բուժման եւ բարդությունների կանխարգելմաննպատակով։</li>
    </ul>
  </div>
  <div className="P-image" />
</div>);

export default SecondPart;
